module.exports = __webpack_public_path__ + "img/chinesecompany33.02fe4a1c.png";